import React, { Fragment, useEffect, useState } from "react"
import { isBrowser } from "../../context/ApolloContext"
import { useForm } from "react-hook-form"
import { FormattedMessage, injectIntl } from "gatsby-plugin-intl"
import { graphql, useStaticQuery } from "gatsby"
import { Oval } from "react-loader-spinner"
import styled from "@emotion/styled"
import { withStoreContext } from "../../context/StoreContext"
import { formSubmitEventScript } from "../../utils/additionalScriptHelpers"

const ExclusifNewsLetterPopup = ({
  storeContext: { checkout, addDiscount },
  intl,
}) => {
  const { register, handleSubmit, errors, reset } = useForm()
  const [NewsTrans, setNewsTrans] = useState({})
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)
  const [success, setSuccess] = useState(null)
  const [userEmail, setuserEmail] = useState("")
  const [firstStepComplete, setFirstStepComplete] = useState(false)
  const [secondStepComplete, setSecondStepComplete] = useState(false)
  const [activeExclusifPopup, setActiveExclusifPopup] = useState(false)

  let emailRegex = new RegExp(
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  )

  const popupClose = () => {
    setFirstStepComplete(false)
    setSecondStepComplete(false)
    setError(null)
    setSuccess(null)
    setActiveExclusifPopup(false)
    reset()
  }

  const data = useStaticQuery(graphql`
    query NewsLetterEurMultipleStepQuery {
      allDirectusNewsletterTranslation {
        nodes {
          email_error_text
          require_error_text
          telephone_error_text
          thanks_text
          email_exist_text
          invalid_email_text
          invalid_dob_text
          language
        }
      }
    }
  `)
  function Translation() {
    if (data && data.allDirectusNewsletterTranslation.nodes.length > 0) {
      let node
      data.allDirectusNewsletterTranslation.nodes.forEach((item, index) => {
        if (item.language === intl.locale) {
          node = index
        }
      })
      if (node >= 0) {
        setNewsTrans(data.allDirectusNewsletterTranslation.nodes[node])
      }
    }
  }

  const onFocus = event => {
    event.target.classList.add("focused")
  }

  const onBlur = event => {
    if (event.target.value === "") {
      event.target.classList.remove("focused")
    }
  }

  const moveSecondStep = async () => {
    setSuccess(null)
    setError(null)

    const baseUrl = `${
      process.env.GATSBY_ACTIVE_ENV != "general"
        ? "/" + process.env.GATSBY_ACTIVE_ENV
        : ""
    }/api/klaviyo-email-subscribe`

    if (emailRegex.test(userEmail)) {
      setLoading(true)

      try {
        const res = await fetch(baseUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            email: userEmail,
            source: "Exclusive Newsletter Form",
            exclusifPopup: true,
          }),
        })

        const data = await res.json()

        if (res.ok) {
          // Success
          setSuccess("Subscribed successfully!")
          setFirstStepComplete(true)
          setSecondStepComplete(false)
        } else {
          // Handle known errors
          const errorType =
            data?.error?.message || data?.error || "internal_error"

          switch (errorType) {
            case "invalid_email":
              setError("Invalid email address.")
              break
            case "no_email_provided":
              setError("Please provide your email address.")
              break
            case "internal_error":
            default:
              setError("Something went wrong. Please try again later.")
              break
          }
        }
      } catch (err) {
        console.error("Network error:", err)
        setError("Network error. Please try again.")
      }

      setLoading(false)
    } else {
      setError(
        intl.formatMessage({
          id: "newsletter_subscribe_invalid_email_error",
        })
      )
    }
  }

  const onSubmit = async data => {
    const { email, telephone } = data

    const baseUrl = `${
      process.env.GATSBY_ACTIVE_ENV != "general"
        ? "/" + process.env.GATSBY_ACTIVE_ENV
        : ""
    }/api/klaviyo-sms-optin`

    setError(null)

    if (!email) {
      setError("Email is required")
      return
    }

    if (Object.keys(errors).length > 0) return

    setLoading(true)

    try {
      const response = await fetch(baseUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email,
          phone: telephone,
          source: "Exclusive Newsletter Form",
          exclusifPopup: true,
        }),
      })

      const result = await response.json()

      if (result.success) {
        formSubmitEventScript("newsletter_submit", intl.locale)
        setError(null)
        setSuccess(NewsTrans.thanks_text)
        setFirstStepComplete(true)
        setSecondStepComplete(true)
      } else {
        if (result.error && result.error.indexOf(email) === 0) {
          setError(NewsTrans.email_exist_text.replace("xxx@xxx", email))
        } else {
          setError(result.error || "Unknown error")
        }
        setFirstStepComplete(false)
        setSuccess(null)
      }
    } catch (err) {
      console.error("Error calling SMS opt-in API:", err)
      setError(
        intl.formatMessage({
          id: "newsletter_subscribe_internal_error",
        })
      )
      setSuccess(null)
    } finally {
      setLoading(false)
    }
  }

  const checkUserEmail = e => {
    var input = e.target.value
    setuserEmail(input)
  }

  const exclusifNewsletterVisibility = () => {
    let popupShown = false

    const showPopup = () => {
      if (!popupShown) {
        popupShown = true
        setActiveExclusifPopup(true)
      }
    }

    // --- Inactivity timer: show after 1 minute of no interaction ---
    let inactivityTimer
    const resetInactivityTimer = () => {
      clearTimeout(inactivityTimer)
      inactivityTimer = setTimeout(() => {
        showPopup()
      }, 60000) // 60 seconds
    }

    ;["mousemove", "keydown", "scroll", "touchstart"].forEach(evt =>
      window.addEventListener(evt, resetInactivityTimer)
    )
    resetInactivityTimer()

    const isMobileDevice = /Mobi|Android/i.test(navigator.userAgent)

    if (isMobileDevice) {
      // --- MOBILE EXIT INTENT FIXED ---

      let lastScrollY = window.scrollY
      let allowScrollDetection = false
      let userHasScrolledDown = false

      // Wait 1s before activating scroll detection (avoid page-load auto-scroll)
      setTimeout(() => {
        allowScrollDetection = true
      }, 1000)

      const scrollHandler = () => {
        const currentScrollY = window.scrollY

        // Track if user scrolled down first
        if (currentScrollY > lastScrollY + 20) {
          userHasScrolledDown = true
        }

        // Only trigger if user scrolled down before and now scrolls up fast
        if (
          allowScrollDetection &&
          userHasScrolledDown &&
          lastScrollY - currentScrollY > window.innerHeight * 0.25
        ) {
          showPopup()
          window.removeEventListener("scroll", scrollHandler)
        }

        lastScrollY = currentScrollY
      }

      window.addEventListener("scroll", scrollHandler, { passive: true })

      // Back button press (Android)
      window.history.pushState(null, "", window.location.href)
      const backButtonHandler = () => {
        showPopup()
        window.history.pushState(null, "", window.location.href)
      }
      window.addEventListener("popstate", backButtonHandler)

      // Visibility change (user switches tab or app)
      const visibilityHandler = () => {
        if (document.visibilityState === "hidden") {
          showPopup()
        }
      }
      document.addEventListener("visibilitychange", visibilityHandler)

      // Page hide (on navigation away)
      const pageHideHandler = () => {
        showPopup()
      }
      window.addEventListener("pagehide", pageHideHandler)

      // Cleanup
      return () => {
        window.removeEventListener("scroll", scrollHandler)
        window.removeEventListener("popstate", backButtonHandler)
        document.removeEventListener("visibilitychange", visibilityHandler)
        window.removeEventListener("pagehide", pageHideHandler)
        ;["mousemove", "keydown", "scroll", "touchstart"].forEach(evt =>
          window.removeEventListener(evt, resetInactivityTimer)
        )
      }
    } else {
      // --- DESKTOP EXIT INTENT ---
      const mouseOutHandler = e => {
        if (!e.toElement && !e.relatedTarget && e.clientY < 50) {
          showPopup()
          document.removeEventListener("mouseout", mouseOutHandler)
        }
      }
      document.addEventListener("mouseout", mouseOutHandler)

      const beforeUnloadHandler = () => showPopup()
      window.addEventListener("beforeunload", beforeUnloadHandler)

      return () => {
        document.removeEventListener("mouseout", mouseOutHandler)
        window.removeEventListener("beforeunload", beforeUnloadHandler)
        ;["mousemove", "keydown", "scroll", "touchstart"].forEach(evt =>
          window.removeEventListener(evt, resetInactivityTimer)
        )
      }
    }
  }

  useEffect(() => {
    if (isBrowser) {
      const cleanup = exclusifNewsletterVisibility()
      return cleanup
    }
  }, [])

  useEffect(() => {
    Translation()
  }, [intl.locale])

  return (
    activeExclusifPopup && (
      <Fragment>
        <NewsletterBoostPopup className="newsletter_weekend_spa_popup">
          <PopupWrapper>
            <BgImage>
              <Image
                src={
                  secondStepComplete
                    ? "https://static.percko.com/uploads/6176e366-b7c4-4b22-9e05-a635418cb110.jpg"
                    : firstStepComplete && !secondStepComplete
                    ? "https://static.percko.com/uploads/11f09cd6-a00f-44ee-a367-d71c11ed4711.jpg"
                    : "https://static.percko.com/uploads/11f09cd6-a00f-44ee-a367-d71c11ed4711.jpg"
                }
              />
            </BgImage>
            <InnerDiv>
              <NewsletterBoostPopupClose onClick={() => popupClose()}>
                ×
              </NewsletterBoostPopupClose>

              <Form onSubmit={handleSubmit(onSubmit)} id="newsletterPopupForm">
                <FirstStep show={!firstStepComplete}>
                  <NewsletterBoostPopupTopBox>
                    <NewsletterTitle>48H POUR RÉFLÉCHIR</NewsletterTitle>
                  </NewsletterBoostPopupTopBox>
                  <NewsletterText
                    dangerouslySetInnerHTML={{
                      __html:
                        "Recevez votre code promo, qui sera valable encore 48h en vous inscrivant à notre newsletter.",
                    }}
                  />
                  <NewsletterBoostPopupMiddle>
                    <FormRow className="form-group">
                      <PopupEmailInput
                        name="email"
                        id="email"
                        ref={register({
                          required: true,
                          pattern: emailRegex,
                        })}
                        aria-invalid={false}
                        onFocus={e => onFocus(e)}
                        onBlur={e => onBlur(e)}
                        onChange={checkUserEmail}
                      />
                      <PopupLabel htmlFor="email">Email</PopupLabel>
                      {errors && errors.email && (
                        <ErrorSpan>
                          {errors.email.type === "pattern"
                            ? NewsTrans.email_error_text
                            : NewsTrans.require_error_text}
                        </ErrorSpan>
                      )}
                      {error && (
                        <Error
                          dangerouslySetInnerHTML={{
                            __html: error,
                          }}
                        />
                      )}
                      <ButtonWrapper>
                        <SecondStepBtn onClick={() => moveSecondStep()}>
                          Je m’inscris à la newsletter
                        </SecondStepBtn>
                      </ButtonWrapper>
                    </FormRow>
                    {success && (
                      <Success
                        dangerouslySetInnerHTML={{
                          __html: success,
                        }}
                      />
                    )}
                    <NewsletterBoostPopupBottom>
                      <FormattedMessage
                        id="exclusif_newsletter_terms_and_conditions_message"
                        values={{
                          terms_and_condition_link: (
                            <a
                              href={intl.formatMessage({
                                id: "terms_and_condition_link.url",
                              })}
                              target="_blank"
                            >
                              {intl.formatMessage({
                                id: "terms_and_condition_link.description",
                              })}
                            </a>
                          ),
                        }}
                      />
                    </NewsletterBoostPopupBottom>
                  </NewsletterBoostPopupMiddle>
                </FirstStep>
                <SecondStep show={firstStepComplete && !secondStepComplete}>
                  <NewsletterText>
                    Et accédez exclusivement aux offres en vous inscrivant aux
                    SMS
                  </NewsletterText>
                  <NewsletterBoostPopupMiddle>
                    <FormRow className="form-group">
                      <PopupEmailInput
                        name="telephone"
                        id="telephone"
                        ref={register({
                          pattern: /^((\+33)) ?\d{3} ?\d{6}$/,
                          min: 9999999999,
                          max: 9999999999999,
                        })}
                        aria-invalid={false}
                        onFocus={e => onFocus(e)}
                        onBlur={e => onBlur(e)}
                      />
                      <PopupLabel htmlFor="telephone">
                        Téléphone portable (+33 6 XX XX XX XX)
                      </PopupLabel>
                      {errors && errors.telephone && (
                        <ErrorSpan>
                          {errors.telephone.type === "pattern"
                            ? NewsTrans.telephone_error_text
                            : NewsTrans.require_error_text}
                        </ErrorSpan>
                      )}
                      {error && (
                        <Error
                          dangerouslySetInnerHTML={{
                            __html: error,
                          }}
                        />
                      )}
                      <ButtonWrapper>
                        <Submit type="submit">Je valide</Submit>
                      </ButtonWrapper>
                    </FormRow>
                    {success && (
                      <Success
                        dangerouslySetInnerHTML={{
                          __html: success,
                        }}
                      />
                    )}
                    <NewsletterBoostPopupBottom>
                      <FormattedMessage
                        id="exclusif_newsletter_terms_and_conditions_message"
                        values={{
                          terms_and_condition_link: (
                            <a
                              href={intl.formatMessage({
                                id: "terms_and_condition_link.url",
                              })}
                              target="_blank"
                            >
                              {intl.formatMessage({
                                id: "terms_and_condition_link.description",
                              })}
                            </a>
                          ),
                        }}
                      />
                    </NewsletterBoostPopupBottom>
                  </NewsletterBoostPopupMiddle>
                </SecondStep>
              </Form>
              <ThirdStep show={secondStepComplete}>
                <NewsletterBoostPopupTopBox>
                  <NewsletterTitle>
                    Merci pour votre inscription.
                  </NewsletterTitle>
                </NewsletterBoostPopupTopBox>
                {success && (
                  <ThankYouText
                    dangerouslySetInnerHTML={{
                      __html:
                        "Vous allez recevoir un mail avec votre code valable 48h.",
                    }}
                  />
                )}
              </ThirdStep>
            </InnerDiv>
          </PopupWrapper>
          <LoaderBox
            style={{
              display: loading ? "flex" : "none",
            }}
          >
            <Oval
              type="Oval"
              color="#808080"
              height={30}
              width={30}
              secondaryColor={"#696969"}
            />
          </LoaderBox>
        </NewsletterBoostPopup>
      </Fragment>
    )
  )
}

const NewsletterBoostPopup = styled.div`
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.75);
  position: fixed;
  z-index: 5;
  top: 0%;
  left: 0%;
`
const PopupWrapper = styled.div`
  max-width: 800px;
  width: 100%;
  position: absolute;
  left: 50%;
  top: 110px;
  transform: translate(-50%, 0px);
  pointer-events: auto;
  display: flex;
  box-shadow: 1px 0px 4px 0px rgba(0, 0, 0, 0.3);
  overflow: hidden;
  background-color: #fff;

  @media (max-width: 767px) {
    width: 90%;
    max-width: 100%;
  }
`

const BgImage = styled.div`
  display: flex;
  width: 100%;
  position: relative;

  @media (max-width: 767px) {
    display: none;
  }
`

const InnerDiv = styled.div`
  display: flex;
  width: 100%;
  position: relative;
  padding: 25px 30px;
  flex-direction: column;
  justify-content: center;
  background: #d7edf6;
  min-height: 360px;

  @media (max-width: 767px) {
    height: auto;
    min-height: 350px;
  }
`

const LoaderBox = styled.div`
  display: none;
  align-items: center;
  justify-content: center;
  background-color: rgba(255, 255, 255, 0.4);
  width: 100%;
  top: 0px;
  left: 0px;
  height: 100%;
  position: absolute;
`

const NewsletterBoostPopupClose = styled.div`
  position: absolute;
  right: 5px;
  line-height: 15px;
  color: #262626;
  top: 5px;
  font-size: 30px;
  cursor: pointer;
`

const FirstStep = styled.div`
  display: ${({ show }) => (show ? "flex" : "none")};
  flex-direction: column;
  width: 100%;
  justify-content: center;
`

const SecondStep = styled.div`
  display: ${({ show }) => (show ? "flex" : "none")};
  flex-direction: column;
  width: 100%;
  justify-content: center;
`

const ThirdStep = styled.div`
  display: ${({ show }) => (show ? "flex" : "none")};
  flex-direction: column;
  width: 100%;
  justify-content: center;
  align-items: center;
`

const Image = styled.img`
  width: 100%;
  margin: 0px;
  object-fit: cover;
`

const NewsletterBoostPopupTopBox = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0px 0px 20px;
`

const NewsletterTitle = styled.div`
  font-size: 40px;
  line-height: 1.2;
  text-transform: uppercase;
  font-family: "BebasNeueBold";
  font-weight: bold;
  text-align: center;
  background: #fff;
  padding: 8px 20px;
  border-radius: 8px;

  @media (max-width: 600px) {
    font-size: 36px;
  }
`

const NewsletterText = styled.div`
  font-family: "Gotham Book";
  font-weight: bold;
  font-size: 14px;
  line-height: 1.2;
  color: #262626;
  margin: 0px 0px 15px;
  text-align: center;

  p {
    margin: 0px 0px 5px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  img {
    margin: 0px 10px 0px 0px;
    max-height: 15px;
  }
`

const ThankYouText = styled.div`
  font-family: "Gotham Book";
  font-weight: bold;
  color: #262626;
  font-size: 14px;
  line-height: 1.2;
  text-align: center;

  p {
    margin: 0px 0px 10px;
  }
`

const NewsletterBoostPopupMiddle = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
  position: relative;
`

const NewsletterBoostPopupBottom = styled.div`
  width: 100%;
  color: #262626;
  font-size: 12px;
  font-weight: bold;
  font-family: "GothamLight";
  text-align: center;
  max-width: 230px;

  a {
    text-decoration: underline;
  }

  a:hover {
    color: #262626;
    text-decoration: underline;
  }

  p {
    margin: 0px;
  }
`

const Form = styled.form`
  display: flex;
  width: 100%;
  margin: 0px;
  flex-direction: column;

  input:-internal-autofill-selected {
    background-color: #f0f !important;
  }

  .focused + label {
    transform: translateY(-110%);
    font-size: 0.75em;
    @media (max-width: 380px) {
      font-size: 0.7em;
    }
  }
`

const FormRow = styled.div`
  width: 100%;
  position: relative;
  flex-direction: column;
  display: flex;
`

const PopupLabel = styled.label`
  position: absolute;
  top: 24px;
  left: 15px;
  transform: translateY(-50%);
  cursor: text;
  transition: transform 150ms ease-out, font-size 150ms ease-out;

  @media (max-width: 600px) {
    font-size: 13px;
  }

  @media (max-width: 400px) {
    font-size: 11px;
  }
`

const PopupEmailInput = styled.input`
  box-sizing: border-box;
  height: 48px;
  width: 100%;
  margin: 0px;
  font-family: "GothamLight";
  color: #0e1116;
  font-weight: bold;
  border: 1px solid #c4c4c4;
  border-radius: 10px;
  box-shadow: none;
  font-size: 12px;
  color: #0e1116;
  ::placeholder {
    color: #0e1116;
  }
  :focus {
    background-color: #fff;
  }
  :-webkit-autofill {
    background: transparent;
  }
`

const ErrorSpan = styled.span`
  color: #b20000;
  font-size: 1em;
`

const ButtonWrapper = styled.div`
  width: 100%;
  margin: 20px 0px;
  text-align: center;
`

const SecondStepBtn = styled.div`
  background: #262626;
  padding: 12px 20px;
  color: #fff;
  font-family: "Museo";
  font-weight: 700;
  font-size: 18px;
  line-height: 1;
  min-width: 220px;
  text-align: center;
  position: relative;
  cursor: pointer;
  border: 0px;
  width: 100%;

  :hover {
    color: #fff;
  }

  @media (max-width: 600px) {
    font-size: 16px;
  }
`

const Submit = styled.button`
  background: #262626;
  padding: 12px 20px;
  color: #fff;
  font-family: "Museo";
  font-weight: 700;
  font-size: 18px;
  line-height: 1;
  min-width: 220px;
  text-align: center;
  position: relative;
  width: 100%;
  cursor: pointer;
  border: 0px;

  :hover {
    color: #fff;
  }

  @media (max-width: 600px) {
    font-size: 16px;
  }
`

const Error = styled.div`
  color: #b20000;
  font-size: 14px;
  line-height: 20px;
  margin: 0.3em 0px 0px;
  width: 100%;
`

const Success = styled.div`
  font-family: "Gotham Book";
  font-weight: bold;
  color: #262626;
  font-size: 14px;
  line-height: 1.2;
  text-align: center;
`

export default injectIntl(withStoreContext(ExclusifNewsLetterPopup))
